import { render, staticRenderFns } from "./dialog-contactbuystorage.vue?vue&type=template&id=b28479a8&"
import script from "./dialog-contactbuystorage.vue?vue&type=script&lang=js&"
export * from "./dialog-contactbuystorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports